import { render, staticRenderFns } from "./DialogCapNhatDienNuocNoiBo.vue?vue&type=template&id=b4190908"
import script from "./DialogCapNhatDienNuocNoiBo.vue?vue&type=script&lang=js"
export * from "./DialogCapNhatDienNuocNoiBo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports